import { useState } from "react";
import { Loader2 } from "lucide-react";

import { SearchInput } from "components/ui";

import { SortByButton } from "./SortByButton";
import styles from "./Table.module.css";

export const Table = ({ items, tableName, isLoading }) => {
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState("a-to-z");

  const sortedAndFilteredItems =
    items
      ?.sort((a, b) => {
        if (sorting === "a-to-z") {
          return a.name.localeCompare(b.name);
        }
        return b.name.localeCompare(a.name);
      })
      .filter(
        (item) =>
          item.name.toLowerCase().includes(search.toLowerCase()) ||
          item.allergyReaction.toLowerCase().includes(search.toLowerCase())
      ) || [];

  const renderTableContent = () => {
    if (isLoading) {
      return (
        <div className={styles.emptyState}>
          <Loader2 className={styles.loadingSpinner} size={24} />
          <p className={styles.emptyStateTitle}>Loading data...</p>
          <p className={styles.emptyStateText}>
            Please wait while we fetch the allergies.
          </p>
        </div>
      );
    }

    if (sortedAndFilteredItems.length === 0) {
      return (
        <div className={styles.emptyState}>
          <p className={styles.emptyStateTitle}>No items found</p>
          <p className={styles.emptyStateText}>
            {search
              ? "Try adjusting your search or filters to find what you're looking for."
              : "There are no items to display at this time."}
          </p>
        </div>
      );
    }

    return (
      <ul className={styles.tableItems}>
        {sortedAndFilteredItems.map((item) => (
          <li className={styles.tableItem} key={item.id}>
            <p aria-describedby={`${tableName}-table-name`}>{item.name}</p>
            <p aria-describedby={`${tableName}-table-symptoms`}>
              {item.allergyReaction}
            </p>
            <p aria-describedby={`${tableName}-table-drugAllergy`}>
              {item.drugAllergyVal}
            </p>
            <p aria-describedby={`${tableName}-table-seriousVal`}>
              {item.seriousVal}
            </p>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <div className={styles.tableWarpper}>
        <div className={styles.table}>
          <div className={styles.tableTopBarWrapper}>
            <SearchInput
              value={search}
              onChange={setSearch}
              placeholder="Search"
              disabled={isLoading}
            />
            <SortByButton
              selectedItem={sorting}
              setSelectedItem={setSorting}
              disabled={isLoading}
            />
          </div>
          <div className={styles.tableHeader}>
            <p id={`${tableName}-table-name`}>Name</p>
            <p id={`${tableName}-table-reaction`}>Symptoms</p>
            <p id={`${tableName}-table-reaction`}>Drug allergy</p>
            <p id={`${tableName}-table-serious`}>Serious</p>
          </div>
          {renderTableContent()}
        </div>
      </div>
    </>
  );
};
